import { render, staticRenderFns } from "./Integral-order.vue?vue&type=template&id=7745b3a0&scoped=true&"
import script from "./Integral-order.vue?vue&type=script&lang=js&"
export * from "./Integral-order.vue?vue&type=script&lang=js&"
import style0 from "./Integral-order.vue?vue&type=style&index=0&id=7745b3a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7745b3a0",
  null
  
)

export default component.exports